var map = {
	"./culturebox.png": 616,
	"./france-2.png": 617,
	"./france-3.png": 618,
	"./france-4.png": 619,
	"./france-5.png": 620,
	"./france-tv.png": 621,
	"./franceinfo.png": 622,
	"./okoo.png": 623,
	"./slash.png": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 615;